<template>
    <IndexBase @auth="onAuth($event)" action="Reset" controller="Appraisal"></IndexBase>

    <OverlayPanel ref="op" :showCloseIcon="true" :dismissable="true" :breakpoints="{ '960px': '75vw', '640px': '100vw' }"
        :style="{ width: '450px' }">
        <InputText v-model="overlayText" @input="onEditRemarks" style="width:100%" />
    </OverlayPanel>

    <Dialog :header="$t('reset_confirmation')" v-model:visible="showResetConfirmationModal" :closeOnEscape="false"
        :closable="false" :modal="true" :breakpoints="{ '960px': '75vw', '640px': '100vw' }" :style="{ width: '35vw' }">
        <div>
            <div v-if="!processed">
                <div>
                    <center>
                        <div class="modal-body" style="background-color:#4682B4; color:white;">
                            <h4>{{ this.$t('message.reset_confirmation') }} ({{ this.nameReset }}) ?</h4>
                        </div>
                    </center>
                </div>
                <div>
                    <center>
                        <div class="alert alert-info">
                            <b>{{ this.lastReset ? this.$t('note.last_reset') : this.$t('note.reset') }}</b>
                        </div>
                    </center>
                </div>
            </div>
            <div v-else>
                <center>
                    <div v-if="resultData.success">
                        <Button icon="pi pi-check" class="p-button-rounded p-button-outlined mr-2 mb-2" /><br>
                        <Button label="Reset Successfully" class="p-button-success p-button-text mr-2 mb-2" />
                    </div>
                    <div v-else>
                        <Button icon="pi pi-times"
                            class="p-button-rounded p-button-danger p-button-outlined mr-2 mb-2" /><br>
                        <Button :label="resultData.message" class="p-button-danger p-button-text mr-2 mb-2" />
                    </div>
                </center>
            </div>
        </div>

        <template #footer>
            <div v-if="processed">
                <Button label="Close" @click="dismissConfirmation" />
            </div>
            <div v-else>
                <div v-if="processing">
                    <ProgressSpinner style="width:50px;height:50px" />
                </div>
                <div v-else>
                    <div v-if="!processed">
                        <Button label="Cancel" @click="dismissConfirmation" />
                        <Button label="Reset" autofocus @click="confirmApproval" class="pi-button p-button-danger" />
                    </div>
                    <div v-else>
                        <Button label="Close" icon="pi pi-times" class="p-button-text" @click="onClose" />
                    </div>
                </div>
            </div>
        </template>
    </Dialog>

    <Card>
        <template #title>
            <Toolbar>
                <template #left>
                    <div class="p-card-title">
                        {{ $t('appraisal_reset') }}
                    </div>
                </template>
            </Toolbar>
        </template>
        <template #content>
            <DataTable ref="dt" responsiveLayout="scroll" class="p-datatable-sm" filterDisplay="row" sortMode="multiple"
                removableSort v-model:expandedRows="expandedRows" stateStorage="local" :stateKey="stateKey"
                :value="dataModel" :loading="!dataModel || loading" :paginator="true" :rows="10" :lazy="true"
                v-model:first="this.start"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50, 100, 500, 1000]"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" @rowExpand="onRowExpand"
                @state-restore="onStateRestore($event)" @state-save="onStateSave($event)" @page="onPage($event)"
                @sort="onSort($event)" @filter="onFilter($event)" @update:selection="onSelect($event)"
                @row-dblclick="onRowDoubleClick" v-model:filters="filters" :totalRecords="totalRecords"
                v-model:selection="selectedRow" dataKey="Id" :metaKeySelection="false">
                <Column :exportable="false" :sortable="false" headerStyle="white-space:nowrap">
                    <template #filter>
                        <Button :label="$t('clear')" icon="pi pi-filter-slash"
                            class="p-button-outlined p-button-primary p-button-sm" @click="clearFilter" :badge="filterBadge"
                            badgeClass="p-badge-danger" />
                    </template>
                    <template #body="dataModel">
                        <Button icon="pi pi-sync" class="p-button-rounded p-button-danger mr-2 p-button-sm"
                            @click="confirm(dataModel.data)" label="Reset" />
                    </template>
                </Column>
                <Column field="NIK" :header="$t('nik')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('nik')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Employee_Name" :header="$t('name')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('name')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Period_Year" :header="$t('period')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('period')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Score" :header="$t('total_score')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('total_score')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                    <template #body="{ data }">
                        {{ data.Score }} %
                    </template>
                </Column>
                <Column field="Rate" :header="$t('rate')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('rate')" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Created_By" :header="$t('input_by')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            :placeholder="$t('input_by')" />
                    </template>
                </Column>
                <Column field="Created_Date" :header="$t('input_date')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker :placeholder="$t('input_date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999"
                            momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()" @date-select="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.Created_Date) }}
                    </template>
                </Column>
                <Column field="S_Edit" :header="$t('edit1_by')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            placeholder="Filter Edited By" />
                    </template>
                </Column>
                <Column field="S_Date" :header="$t('edit1_date')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                            class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" placeholder="Filter Edited Date"
                            @date-select="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.S_Date) }}
                    </template>
                </Column>
                <Column field="H_Edit" :header="$t('edit2_by')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            placeholder="Filter Edited By" />
                    </template>
                </Column>
                <Column field="H_Date" :header="$t('edit2_date')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                            class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" placeholder="Filter Edited Date"
                            @date-select="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.H_Date) }}
                    </template>
                </Column>
                <Column field="F_Edit" :header="$t('edit4_by')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            placeholder="Filter Edited By" />
                    </template>
                </Column>
                <Column field="F_Date" :header="$t('edit4_date')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                            class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" placeholder="Filter Edited Date"
                            @date-select="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.F_Date) }}
                    </template>
                </Column>                
                <Column field="K_Edit" :header="$t('edit3_by')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            placeholder="Filter Edited By" />
                    </template>
                </Column>
                <Column field="K_Date" :header="$t('edit3_date')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                            class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" placeholder="Filter Edited Date"
                            @date-select="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.K_Date) }}
                    </template>
                </Column>
            </DataTable>
        </template>
    </Card>
</template>

<script>
import IndexBase from '../Helper/IndexBase.vue'

export default {
    name: "Appraisal",
    components: {
        'IndexBase': IndexBase
    },
    data() {
        return {
            dataModel: null,
            loading: true,
            totalRecords: 0,
            start: 0,
            stateKey: this.$STATE_NAME + 'appraisal-reset' + this.$store.getters.getUsername,
            isAdmin: this.$store.getters.getIsAdmin,
            sorts: null,
            lazyParams: {},
            filters: null,
            stateFilters: null,
            editorPath: "/Appraisal/Editor",
            dataUrl: "appraisal/listReset",
            resetUrl: "appraisal/reset/",
            canCreate: false,
            canEdit: false,
            canDelete: false,
            canView: false,
            overlayText: "",
            showResetConfirmationModal: false,
            confirmationStatus: "",
            processed: false,
            idReset: 0,
            nameReset: null,
            processing: false,
            pageSize: 10,
            lastReset: false,
        }
    },
    methods: {
        onEditRemarks() {
            this.overlayData.Remarks = this.overlayText;
        },
        toggleRemarksPopup(event, data) {
            this.overlayData = data;
            this.overlayText = data.Remarks;
            this.$refs.op.toggle(event);
        },
        onAuth(event) {
            this.canCreate = event.canCreate;
            this.canEdit = event.canEdit;
            this.canDelete = event.canDelete;
            this.canView = event.canView;
        },
        onPage(event) {
            this.start = event.first;
            this.pageSize = event.rows;
            this.loadLazyData();
        },
        onSort(event) {
            this.sorts = event.multiSortMeta;
            this.loadLazyData();
        },
        onFilter() {
            this.loadLazyData();
        },
        onSelect(event) {
            this.selectedRow = event.data;
        },
        onRowExpand(event) {
            this.expandedRows = [];
            this.expandedRows.push(event.data);
        },
        dismissConfirmation() {
            this.processed = false;
            this.showResetConfirmationModal = false;
            this.loadLazyData();
        },
        confirm(data) {
            this.showResetConfirmationModal = true;
            this.idReset = data.Id;
            this.nameReset = data.Employee_Name;

            if (data.H_Edit == null && data.S_Edit == null && data.K_Edit == null)
                this.lastReset = true;
            else
                this.lastReset = false;
        },
        confirmApproval() {
            var self = this;
            self.submitted = true;
            self.processing = true;

            this.$axios.post(this.$API_URL + this.resetUrl + this.idReset)
                .then((response) => {
                    self.processed = true;
                    self.processing = false;

                    if (response.data.success) {
                        self.resultData = response.data;
                        self.$router.push({ name: "AppraisalResetIndex", params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: response.data.message, life: 3000 } });
                    }
                    else {
                        self.resultData = response.data;
                        self.$router.push({ name: "AppraisalResetIndex", params: { showToast: true, severity: 'error', summary: 'Error', detail: response.data.message, life: 3000 } });
                    }
                })
                .catch(function (err) {
                    self.processed = false;
                    self.processing = false;

                    self.$toast.add({ severity: 'error', summary: "Error", detail: err, life: 3000 });
                });
        },
        filter(mode) {
            this.$router.push({ path: this.filterPath, query: { mode: mode } });
        },
        sidebarMessage(event) {
            this.$toast.add(event);
        },
        loadLazyData() {
            this.loading = true;
            this.selectedRow = null;

            this.lazyParams = {
                start: this.start,
                pageSize: this.pageSize,
                sorts: this.dataSort,
                filters: this.dataFilter
            };

            var self = this;

            this.$axios.post(this.$API_URL + this.dataUrl, this.lazyParams)
                .then((response) => {
                    if (response.data.success) {
                        this.dataModel = response.data.data;
                        this.totalRecords = response.data.totalRecords;
                    }
                    else {
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });
                    }

                    this.loading = false;
                })
                .catch(function (err) {
                    self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: this.$DEFAULT_TIMER });
                    self.loading = false;
                });
        },
        setFilters(defaultPeriod) {
            this.filters = {};
            var exportable = this.$refs.dt.columns.filter(c => c.props.field);
            for (var i = 0; i < exportable.length; i++) {
                var filterValue = null;
                if (defaultPeriod && exportable[i].props.field == 'Period_Year') {
                    filterValue = defaultPeriod;
                }
                else if (this.stateFilters) {
                    var field = this.stateFilters[exportable[i].props.field];
                    if (field) filterValue = field.value;
                }
                this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
            }
        },
        onStateRestore(event) {
            this.start = event.first;
            this.stateFilters = event.filters;
            this.sorts = event.multiSortMeta;
            this.pageSize = event.rows;
        },
        onStateSave(event) {
            event.selectedCategoryIndex = this.selectedCategoryIndex;
        },
        onModalClose() {
            this.loadLazyData();
        },
        clearFilter() {
            this.filters = {};
            var exportable = this.$refs.dt.columns.filter(c => c.props.field);
            for (var i = 0; i < exportable.length; i++) {
                var fieldName = exportable[i].props.field;
                var filterValue = "";
                if (fieldName.includes("Date")) {
                    filterValue = null;
                }
                this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
            }
            this.loadLazyData();
        },
    },
    mounted() {
        this.$emit('unblock-ui');
        this.setFilters(this.$store.getters.getPeriorYear);
        this.loadLazyData();
        this.$showToast();
    },
    computed: {
        dataFilter() {
            var h = [];
            if (this.filters) {
                for (const [key, value] of Object.entries(this.filters)) {
                    h.push({
                        field: key ? key : null,
                        value: value.value,
                        matchMode: value.matchMode
                    });
                }
            }
            return h;
        },
        dataSort() {
            var h = [];
            if (this.sorts) {
                for (var x = 0; x < this.sorts.length; x++) {
                    h.push({
                        field: this.sorts[x].field,
                        order: this.sorts[x].order == 1 ? "ASC" : "DESC"
                    });
                }
            }
            return h;
        },
        filterBadge() {
            var badgeNumber = 0;

            this.dataFilter.filter(function (item) {
                if (item.value && item.field != "Status") {
                    badgeNumber++;
                }
            });

            return badgeNumber;
        },
    },
}
</script>

<style scoped>
.p-card .p-card-content {
    margin: 0 !important;
    padding: 0 !important;
}

.alert-info {
    color: #31708f;
    background-color: #d9edf7;
    border-color: #bce8f1;
}

.alert {
    padding: 15px;
    margin-bottom: 20px;
    border: 1px solid transparent;
    border-radius: 4px;
}
</style>